"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraSlices = void 0;
const Slices_1 = require("./Slices");
class ExtraSlices extends Slices_1.Slices {
    toStringName() {
        return 'ExtraSlices';
    }
}
exports.ExtraSlices = ExtraSlices;
